export const en = {
    title: 'Choose a travel companion',
    description: 'The link for payment will be sent to the support chat after all services are processed',
    add_service_error_message: 'Failed to add service',
    companion_add: 'Add companion',
    title_empty: 'On a business trip with loved ones',
    description_empty: 'We will collect all services and reservations in one place for convenient travel planning for you and your loved ones.',
    add_later: 'Maybe later',
};
